import * as React from "react";
import "./ListStyles.scss";
import { CPListProps } from "../../types";

/**
 * Unstyled list container. Renders a `<ul>` with optional inline layout and configurable item spacing.
 *
 * @example
 * ```tsx
 * // Vertical list
 * <List spacing={1}>
 *   <ListItem>Item One</ListItem>
 *   <ListItem>Item Two</ListItem>
 * </List>
 *
 * // Horizontal inline list
 * <List inline spacing={2}>
 *   <ListItem>Home</ListItem>
 *   <ListItem>About</ListItem>
 * </List>
 * ```
 */
const CPList: React.FC<CPListProps> = ({
  children,
  className,
  style,
  inline = false,
  alignItems = "left",
  spacing = 0,
}) => {
  inline = inline ?? false;

  const margins = {
    marginTop: inline ? "" : `${spacing * 10}px`,
    marginBottom: inline ? "" : `${spacing * 10}px`,
    marginLeft: inline === false ? "" : `${spacing * 10}px`,
    marginRight: inline === false ? "" : `${spacing * 10}px`,
  };

  return (
    <ul
      style={{ listStyle: "none", ...margins, ...style }}
      className={`${className ? className : ""}${
        inline ? "cp-list-inline" : ""
      } ${alignItems === "left" ? "list-left" : "list-right"}`}
    >
      {children}
    </ul>
  );
};

export default CPList;
